<template>
  <div style="height: 100%; background:linear-gradient(to bottom,rgb(5, 20, 90), rgb(6, 27, 114), rgb(3, 50, 165))">
    <div class="contentbox">
      <div class="content">
        <div class="logo">
          <img :src="`${IP_TEST}/uploads/${logopic}`" alt="" @click="$router.push('/')">
        </div>
    
        <div class="inqBox">
            <a class="back" href="/">返回主页</a>
            <div class="allbox">
              <div class="leftBox">
                <div class="inqtype" >
                  <ul>
                    <li @click="inqType='gr'">
                      <a href="javascript:;;" :class="inqType=='gr'?'active':''">
                        个人会员
                      </a>
                      
                    </li>
                    <li @click="inqType='dw'">
                      <a href="javascript:;;" :class="inqType==='dw'?'active':''" >
                        单位会员
                      </a>
                      
                    </li>
                    <li @click="inqType='ban'">
                      <a href="javascript:;;" :class="inqType==='ban'?'active':''" >
                        备案查询
                      </a>
                    </li>
                  </ul>
                </div>
                <div v-if="inqType=='gr'">
                  <input type="text" v-model="cert.name" class="inname" placeholder="姓       名"/>
                  <input type="text" v-model="cert.code" class="incert" placeholder="会员证号"/>
                </div>
                <div v-else-if="inqType=='ban'">
                  <input type="text" v-model="cert.companyname" class="inname" placeholder="企业名称"/>
                  <input type="text" v-model="cert.code" class="incert" placeholder="备案登记号"/>
                </div>
                <div v-else>
                  <input type="text" v-model="cert.companyname" class="inname" placeholder="企业名称"/>
                  <input type="text" v-model="cert.code" class="incert" placeholder="会员证号"/>
                </div>
                <button @click="submitForm() ">查询</button>
                <div class="memberfile">
                  <div class="filetitle">
                    <h2>
                      <img src="/static/img/gfujain.png" alt="">
                    附：会员申请表格：
                    </h2>
                  </div>
                  <div class="filelist">
                    <ul>
                      <li v-for="(file ,index) in applyFiles" :key="index">
                        <router-link v-if="!file.filesrc" :to="`/news/info/${file.plateid}/${file.uuid}`">
                          {{file.title}}
                        </router-link>
                        <a v-else :href="`${IP_TEST}/uploads/${file.filesrc}`" >{{file.title}}</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="rightBox">
                <img src="/static/img/ta.png" alt="">
              </div>
            </div>
        </div>
      </div>
      
    </div>
  </div>
    
  </template>
  
  <script>
  
  import { getPersonalMember,getCompanyMember ,getBeiAn } from '@/request/index';
  import { getCertTypes,getFindPage ,getArticles} from '@/request/get';
  import { IP_TEST } from '@/config'
  const rate = window.outerWidth / 1920;
  export default {
    metaInfo: {
      title: ' 职业发展规划工作项目组',
      meta: [
        {
          name: 'viewport', content:
            `width=1920, user-scalable=yes, initial-scale=${rate}, maximum-scale=${10}, minimum-scale=${rate}`
        }
      ]
    },
    name: "inquery",
    components: {
    },
    computed:{
    logopic() {
      return this.$store.getters.logopic;
    }
  },
    data() {
      return {
        occupations: [],
        occupationFlag:false,
        cert: {
          name: "",
          code:"",
          companyname:""
        },
        applyFiles:[],
        selcertname:"",
        gourl:"",
        certTypes:[],
        inqType:'gr',
        IP_TEST
      }
    },
    created(){
     if(this.$route.query&&this.$route.query.inqtype)
      this.inqType = this.$route.query.inqtype;
     this.getCertTypes();
     this.getFindPage();
  
    },
    mounted() {
      var lastTouchEnd = 0;
      document.addEventListener(
        "touchend",
        function (event) {
          var now = new Date().getTime();
          if (now - lastTouchEnd <= 300) {
            event.preventDefault();
          }
          lastTouchEnd = now;
        },
        false
      );
    },
    methods: {
      async getFindPage() {
        let result = await getFindPage();
        result = result.data || [];
        this.$store.dispatch("SET_PLATES", result)
        let { plates } = this.$store.state;
        let list = plates.filter((item) => '会员附件' == item.name);
        let uuid = list[0].uuid;
        result =  await getArticles(uuid);
        this.applyFiles = result.data ||[];
      },
      goHome() {
        this.$router.push("/");
      },
      handleInq() {
        if (!this.selcertname) {
          this.$message.error("请选择职业名称");
          return;
        }
        for(let i=0;i<this.occupations.length;i++)
        { 
          if(this.occupations[i].certname==this.selcertname)
          {
            this.cert = this.occupations[i];
            break;
          }
        }
        this.$router.push({
          name: "Show",
          query: {
            name: this.cert.name,
            code: this.cert.code,
            certtypename: this.cert.certtypename
          }
        })
      },
      async getCertTypes(){
        let result = await getCertTypes();
        this.certTypes = result.data;
      },
      /**
       *  cname: "单位名称"或姓名,
          ccode: "信用代码"或证件号,
          bzcode: "证书编号"或标准号
      */
      async submitForm() {
        if(this.inqType=='gr')
        {
          if ((this.cert.name == "" && this.cert.code == "")) {
            return;
          }
          let result =await getPersonalMember(this.cert.name,this.cert.code);
          if(result.data.length>0)
          {
            this.$router.push({
              name: "MemberRlt",
              query: {
                name: this.cert.name,
                code: this.cert.code,
                inqType:"gr"
              }
            })
          }else{
            this.$message.error("您输入的会员信息不存在，谨防假冒。");
          }
        }else if(this.inqType=='dw'){
          if ((this.cert.companyname == "" && this.cert.code == "")) {
            return;
          }
          let result =await getCompanyMember(this.cert.companyname,this.cert.code);
          if(result.data.length>0)
          {
            this.$router.push({
              name: "MemberRlt",
              query: {
                companyname: this.cert.companyname,
                code: this.cert.code,
                inqType:"dw"
              }
            })
          }else{
            this.$message.error("您输入的会员信息不存在，谨防假冒。");
          }
        }else if(this.inqType=='ban'){
          if ((this.cert.companyname == "" && this.cert.code == "")) {
            return;
          }
          let result =await getBeiAn(this.cert.companyname,this.cert.code);
          if(result.data.length>0)
          {
            this.$router.push({
              name: "MemberRlt",
              query: {
                companyname: this.cert.companyname,
                code: this.cert.code,
                inqType:"ban"
              }
            })
          }else{
            this.$message.error("您输入的备案信息不存在，谨防假冒。");
          }
        }
       
      }
    }
  };
  </script>
  <style scoped >
  
  .logo{
      text-align: left;
      position: relative;
      top:58px;
  }
  .contentbox{
    height: 100%;
     
      background-image:url(/static/img/bgwebcx.png);
      background-size: contain;
      background-repeat: no-repeat;
  }
  .contentbox .content{
    width: 1200px;
    margin:auto;
  }
  .inqBox{
    background: rgba(148,178,247,0.4);
    border-radius: 16px 16px 16px 16px;
    min-height: 654px;
    opacity: 1;
    padding: 29px;
    position: relative;
    text-align: center;
    top: 122px;
    width: 1080px;
    padding-bottom: 46px;
  }
  .inqBox h1{
      font-size: 32px;
      
      font-weight: bold;
      color: #FFFFFF;
      line-height: 23px;
      text-align: center;
  }
  .leftBox input {
      width: 597px;
      height: 42px;
      background:rgba(13, 0, 94, 0.6);
      margin-top:47px ;
      border-radius: 5px;
      font-size: 16px;
      padding: 14px 10px 14px 23px;
      color: #FFFFFF;
  }
  .leftBox button {
    width: 630px;
    height: 75px;
    margin-top: 47px;
    background:  linear-gradient(22deg, rgba(41,130,242,0.82), rgba(0,63,210,0.82));
    border-radius: 8px 8px 8px 8px;
    font-size: 24px;
    
    font-weight: bold;
    color: #FFFFFF;
    line-height: 28px;
  }
  .allbox{
    margin-top:10px;
    height: 369px;
    display: flex;
  }
  .leftBox{
    width:630px;
    /* height: */
    height: 369px;
   
    display: inline-block;
  }
  .rightBox{
    width:49%;
    height: 369px;
    display: inline-block;
    position: relative;
    margin: auto;
    top: -23px;
    /* position: absolute; */
  }
  .intype >>>.el-input__inner{
    background-color:transparent;
    border:none;
    height: 46px;
      line-height: 46px;
      padding:0px;
      font-size: 16px;
      color: #FFFFFF;
  }
  .kouniu2{
    position: relative;
      top: -67px;
      left: 57px;
      width: 52px;
  }
  .inqtype ul li{
    display: inline-block;
    width: 33%;
    text-align: center;
  }
  .inqtype ul li a{
    color: rgba(255,255,255,0.6);
    font-size: 28px;
    line-height: 53px;
    letter-spacing: 7px;
    
  }
  .inqtype ul li .active::after{
    content: "";
    height: 6px;
    border-radius: 3px;
    display: block;
    background-color: #fff;
    width: 142px;
    margin: auto;
  }
  .memberfile{
    margin-top:47px;
    display: flex;
    padding-top:15px;
    padding-left: 13px;
    min-height: 131px;
    background: rgba(255,255,255,0.12);
    border: 1px solid rgba(29, 21, 124, 0.12);
    padding-bottom: 20px;
  }
  .memberfile img{
    position: relative;
    top: 5px;
  }
  .memberfile .filetitle{
    width: 153px;
    display: inline-block;
  }
  .memberfile .filetitle h2 {
    font-size: 14px;
    color: rgba(255,255,255,0.6);
    text-align: left;
    line-height: 25px;
  }
  .memberfile .filelist{
    width:463px;
    display: inline-block;
    text-align: left;
    line-height: 25px;
  }
  .memberfile .filelist a{
    color: #08008A;
    line-height: 29px;
    font-size: 15px;
    border-bottom: solid 1px;
  }
  .rightBox img{
    position: relative;
    top: 88px;
    left: 23px;
  }
  .inqBox .back{
    font-size: 16px;
    float: right;
    color: #fff;
    border-bottom: solid 1px;
    margin-top: 20px;
  }
  </style>
  